import { Logger, LoggerService } from "@Shared/logger";
import { SETTINGS } from "@Config";
import { InitOptions } from "@Modules/options_module/"
import { DomainUtil, OptionsValidator } from "@Shared/utils";
import { HttpService } from "@Shared/http/http.service";
import { STORAGE } from "@Core";
import { CookiesStorage } from "@Shared/storage";

export class OptionsModuleClass {
    private Logger: Logger = LoggerService.createLogger("OptionsModule");


    private options: InitOptions;

    get Options(): InitOptions {
        return this.options;
    }

    /**
    * Get the base data url (for now just returning the SETTINGS, but in future might want to use siteCode to get custom html)
    */
    get BaseDataUrl(): string {
        return SETTINGS.awsBaseUrl;
    }

    constructor() {
        this.Logger.trace("****  CTOR ****");
    }

    public async init(opts: InitOptions): Promise<void> {
        this.Logger.trace("Options Initializing");        
        try {
            if (!opts) {
                //no passed in options. Check for siteCode in script tag.   
                this.Logger.trace("no passed in options. Getting From Server...");
                const serverOpts = await this.getConfigFromServer();
                opts = serverOpts;
            }
            this.setDefaults(opts);
            
            
            
            return Promise.resolve();
        } catch (error) {
            
            throw error;
            
        }
        
    }

    private setDefaults(opts: InitOptions): void {
        try {
            const defaultValues: Partial<InitOptions> = {
                autoRun: true,
                logEnabled: true,
                logLevel: "Error",
                session: {
                    enabled: false
                },            
                entitlement:{
                    check: false,
                    showCheckScreenOnPageLoad: false,
                    showCheckScreenOnLogin: true,
                    showCheckScreenOnSocialLogin: false,
                    platform: "eedition"
                },
                blueconic: {
                    enabled: false,
                    bcLowaSegments: false,
                },
                event:{
                    trackPerformance: false,
                    GTMOptions:{
                        enabled: false,
                        loadGTM: false,
                        GTMId: "GTM-XXXXXX",
                        dataLayerName: "dataLayer"                        
                    }
                },
                ui:{
                    logo: "https://ui-static-assets-prod.mng-digisubs-prod.com/img/site-logos/MNG_Logo.png",
                    
                    userProfile: {
                        inject: false,
                        showLoading:false,
                        selectorWaitOptions:{
                            maxAttempts: 50,
                            interval: 100
                        },
                        direction: "down",
                        buttons:{
                            subscribe: {
                                title: "Subscribe",
                                url: "https://www.google.com"
                            },
                            login: {
                                title: "Login",
                                url: "https://www.google.com"
                            },
                            register: {
                                title: "Register",
                                url: "https://www.google.com"
                            },
                            contact: {
                                title: "Contact us",
                                url: "https://www.google.com"
                            },
                            logout: {
                                title: "Logout",
                                url: "https://www.google.com"
                            }
                        }
                    },
                    screens:{
                        login:{
                            title: "To continue, please login.",
                            autoShow: false,
                            formOptions:{
                                submitButton:{
                                    text: "Log In",
                                    processingText: "Logging in..."
                                },
                                successMessage: "Login Successful"
                            }
                        },
                        resetPassword:{
                            title: "Enter your email to reset your password.",
                            
                            formOptions:{
                                submitButton:{
                                    text: "Reset Password",
                                    processingText: "Resetting..."
                                },
                                successMessage: "Password Reset Successful"
                            }
                        },
                        register:{
                            title: "Register",
                            formOptions:{
                                submitButton:{
                                    text: "Register",
                                    processingText: "Registering..."
                                },
                                successMessage: "Registration Successful"
                            }
                        },
                        entitlementCheck:{
                            title: "",
                            html: "<div>Getting Subscription Status...</div>"
                        },
                        preAuthCheck:{
                            title: "",
                            html: "Finalizing Authentication...",
                        }
                    }
                }
    
            };
    
            const requiredKeys = {
                siteCode: true,
                auth: true,
                domain: true
            };
    
            const validatedOpts = new OptionsValidator<InitOptions>(
                opts, // User-provided options
                defaultValues,
                requiredKeys
            );
            this.options = validatedOpts.getOptions();
            this.Logger.trace("processed options => [this.options]", this.options);
            let logLevel = this.options.logLevel;
            let logEnabled = this.options.logEnabled;
            
            
            if (CookiesStorage.get("logLevel")) {
                logLevel = CookiesStorage.get("logLevel");
            }
            if (CookiesStorage.get("logEnabled") !== undefined && CookiesStorage.get("logEnabled") !== null) {                
                logEnabled = CookiesStorage.get("logEnabled")
            }            
            LoggerService.setEnabled(logEnabled);
            LoggerService.setLevel(logLevel);    
        } catch (error) {
            throw error;
        }
        
    }

    private async getConfigFromServer(): Promise<InitOptions> {
        this.Logger.info("Fetching site config from server...");
        const siteCode = this.getSiteCode();
        let env = SETTINGS.environment || "";
        const httpService = new HttpService(`${SETTINGS.awsBaseUrl}sites/`, SETTINGS.initCacheTime || 600);
        //need to check if siteCode has Dev or Prod in the name, if so, we don't want to append the environment to the url.
        //This is needed because we are already live on sites in pagesuite that don't include Environment in the name.
        if(siteCode.includes("Dev") || siteCode.includes("Prod") || siteCode.includes("Stage")) {
            env = "";
        }

        return httpService.get<InitOptions>(`${siteCode}${env}.json`, STORAGE.initOptionsCacheKey).then((data) => {
            return Promise.resolve(data);
        }).catch((error) => {
            throw error;
            
        });
    }



    /**
     * This gets the siteCode url param from the auth js script tag.
     * @returns siteCode from js url param.
     */
    private getSiteCode(): string {        
        const siteCode = DomainUtil.getUrlParamFromScriptTag('mng-auth', 'siteCode');        
        return siteCode || "Default";
    }


}

LoggerService.setLogPrefix("%c<<MNG_Auth>>", "mng_auth_");
export const OptionsModule = new OptionsModuleClass();